!(function (e) {
  var t = {};

  function s(l) {
    if (t[l]) return t[l].exports;
    var a = (t[l] = {
      i: l,
      l: !1,
      exports: {},
    });
    return e[l].call(a.exports, a, a.exports, s), (a.l = !0), a.exports;
  }
  (s.m = e),
    (s.c = t),
    (s.d = function (e, t, l) {
      s.o(e, t) ||
        Object.defineProperty(e, t, {
          enumerable: !0,
          get: l,
        });
    }),
    (s.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module",
        }),
        Object.defineProperty(e, "__esModule", {
          value: !0,
        });
    }),
    (s.t = function (e, t) {
      if ((1 & t && (e = s(e)), 8 & t)) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var l = Object.create(null);
      if (
        (s.r(l),
        Object.defineProperty(l, "default", {
          enumerable: !0,
          value: e,
        }),
        2 & t && "string" != typeof e)
      )
        for (var a in e)
          s.d(
            l,
            a,
            function (t) {
              return e[t];
            }.bind(null, a)
          );
      return l;
    }),
    (s.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return s.d(t, "a", t), t;
    }),
    (s.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (s.p = "/"),
    s((s.s = 1));
})({
  1: function (e, t, s) {
    e.exports = s("YsiF");
  },
  YsiF: function (e, t) {
    window.Element &&
      !Element.prototype.closest &&
      (Element.prototype.closest = function (e) {
        var t,
          s = (this.document || this.ownerDocument).querySelectorAll(e),
          l = this;
        do {
          for (t = s.length; --t >= 0 && s.item(t) !== l; );
        } while (t < 0 && (l = l.parentElement));
        return l;
      }),
      "NodeList" in window &&
        !NodeList.prototype.forEach &&
        (NodeList.prototype.forEach = function (e, t) {
          t = t || window;
          for (var s = 0; s < this.length; s++) e.call(t, this[s], s, this);
        });
    var s = {
      init: function () {
        (customerID = window.hulkappsWishlist.customerID),
          (hulkShopDomain = window.hulkappsWishlist.domain),
          (customerStatus = "Customer"),
          (wishlistProductsData = []),
          (selectedWishlist = {}),
          (selectedLayout = "list"),
          (DefaultWishlistID = ""),
          (SelectedWishlistID = ""),
          (searchTerm = ""),
          (appStatus = !1),
          (guestWishlistData = localStorage.getItem(
            "HulkApps-wishlist-guestData"
          )),
          (wishlistTotal = document.querySelector("[data-totalwishlistitems]")),
          (productIDListing = ""),
          guestWishlistData &&
          void 0 !== guestWishlistData &&
          null !== guestWishlistData
            ? (guestWishlistData = JSON.parse(guestWishlistData))
            : (guestWishlistData = []),
          (null != customerID && null != customerID && "" != customerID) ||
            (customerStatus = "guest"),
          wishlistTotal && s._updateWishlistTotal(),
          s._getShopSettings();
      },
      _guestWishlistAPI: function (e, t) {
        var l =
            window.hulkappsWishlist.baseURL +
            "/wishlist/products/guest?product_ids=" +
            e +
            "&page=" +
            t +
            "&shop=" +
            hulkShopDomain +
            "&search=" +
            searchTerm,
          a = new XMLHttpRequest();
        a.open("GET", l, !0),
          a.send(),
          (a.onload = function () {
            if (200 == a.status) {
              var e = JSON.parse(this.response);
              (selectedWishlist = e),
                s._wishlistLayout(selectedLayout, selectedWishlist),
                selectedWishlist.total > 0
                  ? (document.querySelectorAll(
                      "[data-HulkEmptyWishlist]"
                    )[0].style.display = "none")
                  : (document.querySelectorAll(
                      "[data-HulkEmptyWishlist]"
                    )[0].style.display = "block"),
                s._updatewishlistPagination(selectedWishlist),
                selectedWishlist.last_page > 1
                  ? (document.querySelectorAll(
                      "[data-HulkPagination]"
                    )[0].style.display = "flex")
                  : (document.querySelectorAll(
                      "[data-HulkPagination]"
                    )[0].style.display = "none");
            } else {
              var t = JSON.parse(this.response),
                l = "Something Went wrong. Please Try again later !";
              t.message && (l = t.message), s._messageUpdate(l);
            }
          });
      },
      _slider: function () {
        var e = document.querySelectorAll(".carousel .item"),
          t = document.querySelectorAll(".carousel-indicators li"),
          s = 0,
          l = !0;

        function a(t) {
          s = (t + e.length) % e.length;
        }

        function i(a) {
          (l = !1),
            e[s].classList.add(a),
            t[s].classList.remove("active"),
            e[s].classList.remove("active", a);
        }

        function r(a) {
          e[s].classList.add("next", a),
            t[s].classList.add("active"),
            e[s].classList.remove("next", a),
            e[s].classList.add("active"),
            (l = !0);
        }
        document
          .querySelector(".carousel-control.left")
          .addEventListener("click", function () {
            var e;
            l && ((e = s), i("to-right"), a(e - 1), r("from-left"));
          }),
          document
            .querySelector(".carousel-control.right")
            .addEventListener("click", function () {
              var e;
              l && ((e = s), i("to-left"), a(e + 1), r("from-right"));
            }),
          document
            .querySelector(".carousel-indicators")
            .addEventListener("click", function (e) {
              var l,
                a = [].slice
                  .call(e.target.parentNode.children)
                  .indexOf(e.target);
              a !== s &&
                a < t.length &&
                ((l = a) < s
                  ? (i("to-right"), (s = l), r("from-left"))
                  : (i("to-left"), (s = l), r("from-right")));
            });
      },
      _updateGuestProducts: function (e, t) {
        productIDListing = "";
        var l = e.length,
          a = 0;
        e.forEach(function (e, t) {
          (a += 1),
            (productIDListing += e.productID),
            a < l && (productIDListing += ",");
        }),
          s._guestWishlistAPI(productIDListing, t);
      },
      _getShopSettings: function () {
        var e =
            window.hulkappsWishlist.baseURL +
            "/shop/settings?shop=" +
            hulkShopDomain,
          t = new XMLHttpRequest();
        t.open("GET", e, !0),
          t.send(),
          (t.onload = function () {
            var e = JSON.parse(this.response);
            if (
              ((WishlistSettings = e),
              (appStatus = WishlistSettings.general.frontend_enabled),
              0 == appStatus)
            )
              return (
                (document.querySelectorAll(
                  "[data-wishlistcontainer]"
                )[0].innerHTML =
                  '<h3 style="width: 100%; text-align: center">No Data Found!</h3>'),
                document
                  .querySelectorAll("[data-wishlistcontainer]")[0]
                  .classList.remove("grid_9"),
                void document
                  .querySelectorAll("[data-wishlistcontainer]")[0]
                  .classList.add("grid_12")
              );
            "guest" == customerStatus &&
              (guestWishlistData.length <= 0 ||
              null == guestWishlistData ||
              null == guestWishlistData
                ? ((document.querySelectorAll(
                    "[data-wishlistcontainer]"
                  )[0].style.display = "none"),
                  (document.querySelectorAll(
                    "[data-HulkLoginMsg]"
                  )[0].style.display = "block"))
                : (document
                    .getElementsByClassName("sidebar_container")[0]
                    .remove(),
                  document
                    .querySelectorAll("[data-wishlistcontainer]")[0]
                    .classList.remove("grid_9"),
                  document
                    .querySelectorAll("[data-wishlistcontainer]")[0]
                    .classList.add("grid_12"),
                  s._updateGuestProducts(guestWishlistData, 1))),
              "guest" != customerStatus &&
                (0 == WishlistSettings.general.has_multiple_wishlist
                  ? (document.getElementsByClassName("sidebar_container")[0] &&
                      document
                        .getElementsByClassName("sidebar_container")[0]
                        .remove(),
                    document.querySelectorAll("[data-wishlistcontainer]")[0] &&
                      (document
                        .querySelectorAll("[data-wishlistcontainer]")[0]
                        .classList.remove("grid_9"),
                      document
                        .querySelectorAll("[data-wishlistcontainer]")[0]
                        .classList.add("grid_12")))
                  : document.getElementsByClassName("sidebar_container")[0] &&
                    (document.getElementsByClassName(
                      "sidebar_container"
                    )[0].style.display = "block"),
                1 != WishlistSettings.general.can_share_wishlist &&
                  document
                    .querySelectorAll("[data-forMultipleDisabled]")[0]
                    .querySelector("[data-HulkShareWishList]")
                    .remove(),
                1 != WishlistSettings.general.can_subscribe_wishlist &&
                  document
                    .querySelectorAll("[data-forMultipleDisabled]")[0]
                    .querySelector("[data-HulkSubscribetoList]")
                    .remove(),
                s._getUserWishlist(),
                s._updateWishlistText(),
                s._updateWishlistButton(),
                s._createNewWishlist(),
                s._deleteHulkWishlist(),
                s._shareWishlist(),
                s._subscribeWishlist(),
                setTimeout(function () {
                  (SelectedWishlistID = DefaultWishlistID),
                    s._getWishlistProducts(DefaultWishlistID, 1);
                }, 1e3)),
              s._removeFromWishlist(),
              s._updatePixels(),
              s._addProductTocart(),
              s._someBaseFunction(),
              s._searchWishlist(),
              s._hulkQuickView(),
              0 == WishlistSettings.general.delete_on_move_to_wishlist &&
                (WishlistSettings.language.button.move_to_cart = "Add To Cart");
          });
      },
      _messageUpdate: function (e) {
        var t = document.querySelectorAll(".wishlistError")[0];
        null != t &&
          null != t &&
          ((t.innerHTML = e),
          t.classList.add("hulkActive"),
          setTimeout(function () {
            t.classList.remove("hulkActive");
          }, 5e3));
      },
      _updateWishlistText: function () {
        (document.querySelectorAll("[data-wishlistsearch]")[0].placeholder =
          WishlistSettings.language.placeholder_searchbox),
          (document.querySelectorAll("[data-createWishlistText]")[0].innerHTML =
            WishlistSettings.language.wishlist.create),
          (document.querySelectorAll("[data-myWishlistText]")[0].innerHTML =
            WishlistSettings.language.wishlist.my),
          (document.querySelectorAll("[data-popupTitle]")[0].innerHTML =
            WishlistSettings.language.popup.title),
          (document.querySelectorAll("[data-popupSubTitle]")[0].innerHTML =
            WishlistSettings.language.popup.subscribe_message),
          (document.querySelectorAll(
            "[data-hulksubscribebutton]"
          )[0].innerHTML = WishlistSettings.language.subscribe.button_text);
      },
      _updateWishlistButton: function () {
        var e,
          t = WishlistSettings.style;
        (e =
          "background-color: " +
          WishlistSettings.style.theme_color +
          "; border: 1px solid " +
          WishlistSettings.style.theme_color +
          "; color: white;"),
          document.querySelectorAll(".hulkThemeColor").forEach(function (e) {
            e.setAttribute("style", "color: " + t.theme_color);
          }),
          document.querySelectorAll(".hulkBtnStyle").forEach(function (t) {
            t.setAttribute("style", e);
          });
      },
      _getUserWishlist: function () {
        var e =
            window.hulkappsWishlist.baseURL +
            "/wishlist/lists?customer_id=" +
            customerID +
            "&shop=" +
            hulkShopDomain,
          t = new XMLHttpRequest();
        t.open("GET", e, !0),
          t.setRequestHeader('Encrypt-token', btoa(CryptoJS.SHA256('planet-organic-uk.myshopify.com'+customerID).toString()));
          (t.onload = function () {
            if (200 == t.status) {
              var e = JSON.parse(this.response);
              e.forEach(function (e) {
                1 != e.is_default || (DefaultWishlistID = e.id);
              }),
                "" == SelectedWishlistID &&
                  (SelectedWishlistID = DefaultWishlistID),
                sessionStorage.setItem("wishlistsData", JSON.stringify(e)),
                s._updateWishlistHTML(e);
            } else {
              var l = JSON.parse(this.response),
                a = "Something Went wrong. Please Try again later !";
              l.message && (a = l.message), s._messageUpdate(a);
            }
          }),
          t.send();
      },
      _updateWishlistHTML: function (e) {
        var t = "";
        e.forEach(function (e) {
          1 == e.is_default &&
            0 == WishlistSettings.general.has_multiple_wishlist &&
            ((document.querySelectorAll("[data-wishlistTitle]")[0].innerHTML =
              e.name),
            (document.querySelectorAll(
              "[data-forMultipleDisabled]"
            )[0].style.display = "block"),
            document
              .querySelectorAll("[data-forMultipleDisabled]")[0]
              .querySelector("[data-HulkShareWishList]") &&
              document
                .querySelectorAll("[data-forMultipleDisabled]")[0]
                .querySelector("[data-HulkShareWishList]")
                .setAttribute("data-uniqId", e.unique_identifier),
            document
              .querySelectorAll("[data-forMultipleDisabled]")[0]
              .querySelector("[data-HulkSubscribetoList]") &&
              (document
                .querySelectorAll("[data-forMultipleDisabled]")[0]
                .querySelector("[data-HulkSubscribetoList]")
                .setAttribute("data-id", e.id),
              document
                .querySelectorAll("[data-forMultipleDisabled]")[0]
                .querySelector("[data-HulkSubscribetoList]")
                .setAttribute("data-email", e.subscribed_email),
              1 == e.is_subscribed &&
                (document
                  .querySelectorAll("[data-forMultipleDisabled]")[0]
                  .querySelector("[data-HulkSubscribetoList]").innerHTML =
                  "Subscribed"))),
            e.id == parseInt(SelectedWishlistID)
              ? (!0,
                (t +=
                  '<li class="sidebar_item active" data-id="' +
                  e.id +
                  '" data-email="' +
                  e.subscribed_email +
                  '" data-subscribed="' +
                  e.subscribed_email +
                  '" data-uniqId="' +
                  e.unique_identifier +
                  '" data-userHulkwishlist>'))
              : (t +=
                  '<li class="sidebar_item" data-id="' +
                  e.id +
                  '" data-email="' +
                  e.subscribed_email +
                  '" data-uniqId="' +
                  e.unique_identifier +
                  '" data-userHulkwishlist>'),
            (t +=
              '<div class="sidebar_content"><a href="#" class="h6 Wishlist_cat_title" data-HulkwishlistView>' +
              e.name +
              " <span>(" +
              e.total_products +
              ')</span></a><p class="share_sbcrb">'),
            WishlistSettings.general.can_share_wishlist &&
              1 == e.can_share_wishlist &&
              (t += '<a href="#" data-HulkShareWishList>Share</a>'),
            1 == WishlistSettings.general.can_subscribe_wishlist &&
            1 == e.is_subscribed
              ? (t +=
                  '<a href="#" data-HulkSubscribetoList> Subscribed</a></p></div>')
              : 1 == WishlistSettings.general.can_subscribe_wishlist &&
                (t +=
                  '<a href="#" data-HulkSubscribetoList> Subscribe</a></p></div>'),
            (t += "</p>"),
            0 == e.is_default &&
              (t +=
                '</div><div class="content_remove" data-confirmDeleteWishlist><a href="#" class="icon-wishlist-bin hulkThemeColor delete-wishlist"></a></div>'),
            (t += "</li>");
        });
        var s = document.querySelectorAll("[data-HulkWishlistListing]")[0];
        "" == SelectedWishlistID && (SelectedWishlistID = DefaultWishlistID),
          void 0 !== s &&
            null != s &&
            (document.querySelectorAll(
              "[data-HulkWishlistListing]"
            )[0].innerHTML = t);
      },
      _subscribeWishlist: function () {
        document.addEventListener("click", function (e) {
          if (
            e.target &&
            1 == e.target.hasAttribute("data-HulkSubscribetoList")
          ) {
            e.preventDefault();
            var t,
              s,
              l = e.target;
            if (
              (l.closest("[data-userhulkwishlist]")
                ? ((t = l
                    .closest("[data-userhulkwishlist]")
                    .getAttribute("data-id")),
                  (s = l
                    .closest("[data-userhulkwishlist]")
                    .getAttribute("data-email")))
                : ((t = l.getAttribute("data-id")),
                  (s = l.getAttribute("data-email"))),
              null == t || null == t)
            )
              return;
            document
              .querySelectorAll("[data-hulksubscribeform]")[0]
              .setAttribute("data-id", t),
              document
                .querySelectorAll("[data-HulkappsSubscribe]")[0]
                .classList.add("open"),
              (document.querySelectorAll(
                '[data-HulkSubscribeForm] [name="email"]'
              )[0].value = "null" != s && null != s ? s : "");
          }
        }),
          document
            .querySelectorAll("[data-HulkSubscribeButton]")[0]
            .addEventListener("click", function (e) {
              e.preventDefault();
              var t = e.target
                .closest("[data-HulkSubscribeForm]")
                .getAttribute("data-id");
              if (null != t && null != t && "" != t && t.length > 0) {
                var l = document.querySelectorAll(
                  '[data-HulkSubscribeForm] [name="email"]'
                )[0].value;
                if ((null != l && null != l && (l = l.trim()), l.length <= 0))
                  alert("Enter Email!");
                else if (0 == s._emailValidation(l))
                  alert("Enter Valid Email!");
                else {
                  var a = {
                      customer_id: customerID,
                      shop: hulkShopDomain,
                      wishlist_id: t,
                      email: l,
                    },
                    i = new XMLHttpRequest();
                  i.open(
                    "POST",
                    window.hulkappsWishlist.baseURL + "/wishlist/subscribe",
                    !0
                  ),
                    i.setRequestHeader("Content-type", "application/json"),
                    i.send(JSON.stringify(a)),
                    (i.onload = function () {
                      if (200 == i.status) {
                        JSON.parse(this.response);
                        s._getUserWishlist(),
                          0 == WishlistSettings.general.has_multiple_wishlist &&
                            document
                              .querySelectorAll("[data-forMultipleDisabled]")[0]
                              .querySelector("[data-HulkSubscribetoList]") &&
                            (document
                              .querySelectorAll("[data-forMultipleDisabled]")[0]
                              .querySelector(
                                "[data-HulkSubscribetoList]"
                              ).innerHTML = "Subscribed"),
                          document
                            .querySelectorAll("[data-HulkappsSubscribe]")[0]
                            .classList.remove("open"),
                          document
                            .querySelectorAll("[data-HulkSubscribeForm]")[0]
                            .removeAttribute("data-id"),
                          (document.querySelectorAll(
                            '[data-HulkSubscribeForm] [name="email"]'
                          )[0].value = "");
                      } else {
                        var e = JSON.parse(this.response),
                          t = "Something Went wrong. Please Try again later !";
                        e.message && (t = e.message), s._messageUpdate(t);
                      }
                    });
                }
              }
            });
      },
      _shareWishlist: function () {
        document.addEventListener("click", function (e) {
          if (
            e.target &&
            1 == e.target.hasAttribute("data-HulkShareWishList")
          ) {
            e.preventDefault();
            var t,
              s = e.target;
            if (
              null ==
                (t = s.closest("[data-userhulkwishlist]")
                  ? s
                      .closest("[data-userhulkwishlist]")
                      .getAttribute("data-uniqId")
                  : s.getAttribute("data-uniqId")) ||
              null == t
            )
              return;
            var l = window.location.hostname,
              a =
                window.location.protocol +
                "//" +
                l +
                "/apps/advanced-wishlist/share?listID=" +
                t,
              i = "https://www.facebook.com/sharer/sharer.php?u=" + a,
              r =
                "https://twitter.com/share?text=Checkout My wishlist &amp;url=" +
                a,
              n =
                "https://pinterest.com/pin/create/button/?url=" +
                a +
                "&amp;description=Checkout My Wishlist",
              o =
                "mailto:?subject=I wanted you to check out this wishlist at " +
                a;
            document
              .querySelectorAll("[data-HulkappsShare]")[0]
              .classList.add("open"),
              (document.querySelectorAll("[data-shareURL]")[0].value = a),
              document
                .querySelectorAll("[data-shareFacebook]")[0]
                .setAttribute("href", i),
              document
                .querySelectorAll("[data-shareTwitter]")[0]
                .setAttribute("href", r),
              document
                .querySelectorAll("[data-sharePintrest]")[0]
                .setAttribute("href", n),
              document
                .querySelectorAll("[data-shareTumblr]")[0]
                .setAttribute("href", o);
          }
        }),
          null != document.querySelectorAll("[data-copyshareURLButtom]")[0] &&
            null != document.querySelectorAll("[data-saveNewWishlist]")[0] &&
            (document.querySelectorAll("[data-copyshareURLButtom]")[0].onclick =
              function (e) {
                e.preventDefault();
                var t = document.getElementById("shareURL");
                t.select(),
                  t.setSelectionRange(0, 99999),
                  document.execCommand("copy"),
                  alert("Link has been copied!");
              });
      },
      _createNewWishlist: function () {
        document.querySelectorAll("[data-saveNewWishlist]")[0].onclick =
          function (e) {
            e.preventDefault();
            e.target;
            var t = document
              .querySelectorAll("[data-addNewWishlist]")[0]
              .querySelector("[data-newWishlist]").value;
            if ((t = t.trim()).length > 0) {
              document
                .querySelectorAll("[data-addNewWishlist]")[0]
                .querySelectorAll("[data-newWishlist]")[0]
                .classList.remove("error");
              var l = {
                  customer_id: customerID,
                  shop: hulkShopDomain,
                  name: t,
                },
                a = new XMLHttpRequest();
              a.open(
                "POST",
                window.hulkappsWishlist.baseURL + "/wishlist/create",
                !0
              ),
                a.setRequestHeader("Content-type", "application/json"),
                a.send(JSON.stringify(l)),
                (a.onload = function () {
                  if (200 == a.status) {
                    var e = JSON.parse(this.response);
                    (document.querySelectorAll(
                      "[data-openCreateSection]"
                    )[0].style.display = "block"),
                      (document.querySelectorAll(
                        "[data-addNewWishlist]"
                      )[0].style.display = "none"),
                      (document.querySelectorAll(
                        "[data-newwishlist]"
                      )[0].value = ""),
                      s._getUserWishlist();
                    var t = "Wishlist Created!";
                    e.message && (t = e.message), s._messageUpdate(t);
                  } else {
                    var l = JSON.parse(this.response),
                      i = "Something Went wrong. Please Try again later !";
                    l.message && (i = l.message), s._messageUpdate(i);
                  }
                });
            } else
              document
                .querySelectorAll("[data-addNewWishlist]")[0]
                .querySelectorAll("[data-newWishlist]")[0]
                .classList.add("error");
          };
      },
      _deleteHulkWishlist: function () {
        document.addEventListener("click", function (e) {
          if (
            (e.target &&
              1 == e.target.hasAttribute("data-confrimDeleteWishlist")) ||
            1 == e.target.classList.contains("delete-wishlist")
          ) {
            e.preventDefault();
            var t = e.target
              .closest("[data-userhulkwishlist]")
              .getAttribute("data-id");
            document
              .querySelectorAll("[data-hulkappsdeleteprompt]")[0]
              .setAttribute("data-wishlist", t),
              document
                .querySelectorAll("[data-hulkappsDeletePrompt]")[0]
                .classList.add("open");
          }
        }),
          document.addEventListener("click", function (e) {
            if (
              e.target &&
              1 == e.target.hasAttribute("data-deletehulkwishlist")
            ) {
              e.preventDefault();
              var t = e.target,
                l = t
                  .closest("[data-hulkappsdeleteprompt]")
                  .getAttribute("data-wishlist"),
                a = {
                  customer_id: customerID,
                  shop: hulkShopDomain,
                  wishlist_id: l,
                };
              if (null == l || null == l) {
                document
                  .querySelectorAll("[data-hulkappsDeletePrompt]")[0]
                  .classList.remove("open"),
                  document
                    .querySelectorAll("[data-hulkappsDeletePrompt]")[0]
                    .removeAttribute("data-wishlist");
                return void s._messageUpdate(
                  "Please select wishlist to delete."
                );
              }
              var i = !1;
              SelectedWishlistID == l && (i = !0), t.classList.add("disabled");
              var r = new XMLHttpRequest();
              r.open(
                "POST",
                window.hulkappsWishlist.baseURL + "/wishlist/delete",
                !0
              ),
                r.setRequestHeader("Content-type", "application/json"),
                r.send(JSON.stringify(a)),
                (r.onload = function () {
                  if (200 == r.status) {
                    var e = JSON.parse(this.response);
                    (document.querySelectorAll(
                      "[data-openCreateSection]"
                    )[0].style.display = "block"),
                      (document.querySelectorAll(
                        "[data-addNewWishlist]"
                      )[0].style.display = "none"),
                      document
                        .querySelectorAll("[data-hulkappsDeletePrompt]")[0]
                        .classList.remove("open"),
                      document
                        .querySelectorAll("[data-hulkappsDeletePrompt]")[0]
                        .removeAttribute("data-wishlist"),
                      (document.querySelectorAll(
                        "[data-newwishlist]"
                      )[0].value = ""),
                      t.classList.remove("disabled"),
                      1 == i &&
                        document.querySelectorAll(
                          '[data-userhulkwishlist][data-id="' +
                            DefaultWishlistID +
                            '"]'
                        ) &&
                        document
                          .querySelectorAll(
                            '[data-userhulkwishlist][data-id="' +
                              DefaultWishlistID +
                              '"]'
                          )[0]
                          .querySelector("[data-hulkwishlistview]")
                          .click(),
                      s._getUserWishlist();
                    var l = "Wishlist Has been Deleted!";
                    e.message && (l = e.message),
                      s._messageUpdate(l),
                      wishlistTotal && s._updateWishlistTotal();
                  } else {
                    var a = JSON.parse(this.response),
                      n = "Something Went wrong. Please Try again later !";
                    a.message && (n = a.message),
                      s._messageUpdate(n),
                      document
                        .querySelectorAll("[data-data-hulkappsDeletePrompt]")[0]
                        .classList.remove("open"),
                      document
                        .querySelectorAll("[data-data-hulkappsDeletePrompt]")[0]
                        .removeAttribute("data-wishlist");
                  }
                });
            }
          });
      },
      _removeFromGuestWishlist: function (e) {
        var t;
        guestWishlistData.forEach(function (s, l) {
          s.productID !== e || (t = l);
        }),
          1 == guestWishlistData.length
            ? (guestWishlistData = [])
            : null != t && guestWishlistData.splice(t, 1),
          localStorage.setItem(
            "HulkApps-wishlist-guestData",
            JSON.stringify(guestWishlistData)
          ),
          s._updateProductForGuest(e);
        var l = document
          .querySelectorAll("[data-hulkpagination]")[0]
          .querySelector("[data-currentpage]").innerHTML;
        s._updateGuestProducts(guestWishlistData, l);
      },
      _updateProductForGuest: function (e) {
        var t = {
            shop: hulkShopDomain,
            product_id: e,
          },
          l =
            window.hulkappsWishlist.baseURL + "/wishlist/delete_product/guest",
          a = new XMLHttpRequest();
        a.open("POST", l),
          a.setRequestHeader("Content-type", "application/json"),
          a.send(JSON.stringify(t)),
          (a.onload = function () {
            if (200 == a.status);
            else {
              var e = JSON.parse(this.response),
                t = "Something went wrong! Please Try again later.";
              e.message && (t = e.message), s._messageUpdate(t);
            }
          }),
          wishlistTotal && s._updateWishlistTotal();
      },
      _emailValidation: function (e) {
        return 0 != /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/gim.test(e);
      },
      _getWishlistProducts: function (e, t) {
        if (null != customerID && null != customerID) {
          var l =
              window.hulkappsWishlist.baseURL +
              "/wishlist/products?page=" +
              t +
              "&customer_id=" +
              customerID +
              "&shop=" +
              hulkShopDomain +
              "&wishlist_id=" +
              e +
              "&search=" +
              searchTerm,
            a = new XMLHttpRequest();
          a.open("GET", l, !0),
            a.setRequestHeader('Encrypt-token', btoa(CryptoJS.SHA256('planet-organic-uk.myshopify.com'+customerID).toString()));
            (a.onload = function () {
              if (200 == a.status) {
                var t = JSON.parse(this.response);
                selectedWishlist = t;
                var l = document.querySelectorAll("[data-userhulkwishlist]");
                if ("" != e)
                  for (var i = 0; i < l.length; i++)
                    l[i].classList.remove("active");
                var r = document.querySelectorAll(
                  '[data-userhulkwishlist][data-id="' + e + '"]'
                )[0];
                void 0 !== r &&
                  null != r &&
                  document
                    .querySelectorAll(
                      '[data-userhulkwishlist][data-id="' + e + '"]'
                    )[0]
                    .classList.add("active"),
                  s._wishlistLayout(selectedLayout, selectedWishlist),
                  selectedWishlist.total > 0
                    ? (document.querySelectorAll(
                        "[data-HulkEmptyWishlist]"
                      )[0].style.display = "none")
                    : (document.querySelectorAll(
                        "[data-HulkEmptyWishlist]"
                      )[0].style.display = "block"),
                  s._updatewishlistPagination(selectedWishlist),
                  selectedWishlist.last_page > 1
                    ? (document.querySelectorAll(
                        "[data-HulkPagination]"
                      )[0].style.display = "flex")
                    : (document.querySelectorAll(
                        "[data-HulkPagination]"
                      )[0].style.display = "none");
              } else {
                var n = JSON.parse(this.response),
                  o = "Something Went wrong. Please Try again later !";
                n.message && (o = n.message), s._messageUpdate(o);
              }
            }),
            a.send();
        }
      },
      _updatewishlistPagination: function (e) {
        var t = e.current_page + 1,
          s = e.current_page - 1;
        s <= 0 && (s = 1),
          (document.querySelectorAll("[data-currentPage]")[0].innerHTML =
            e.current_page),
          null != e.prev_page_url
            ? (document
                .querySelectorAll("[data-prevPage]")[0]
                .setAttribute("href", e.prev_page_url),
              document
                .querySelectorAll("[data-prevPage]")[0]
                .setAttribute("data-page", s),
              (document.querySelectorAll("[data-prevPage]")[0].style.display =
                "block"))
            : (document.querySelectorAll("[data-prevPage]")[0].style.display =
                "none"),
          null != e.next_page_url && e.current_page != e.last_page
            ? (document
                .querySelectorAll("[data-nextPage]")[0]
                .setAttribute("href", e.next_page_url),
              document
                .querySelectorAll("[data-nextPage]")[0]
                .setAttribute("data-page", t),
              (document.querySelectorAll("[data-nextPage]")[0].style.display =
                "block"))
            : (document.querySelectorAll("[data-nextPage]")[0].style.display =
                "none");
        var l = document
          .querySelectorAll("[data-hulkpagination]")[0]
          .querySelector("[data-currentpage]").innerHTML;
        null != l &&
          null != l &&
          parseInt(l) > e.last_page &&
          document
            .querySelectorAll("[data-hulkpagination]")[0]
            .querySelector("[data-prevpage]")
            .click();
      },
      _wishlistLayout: function (e, t) {
        var l = t.data,
          a = "";
        l &&
          ("grid" == e
            ? (l.forEach(function (e) {
                console.log(e.product_id);
                const categoriesString = e.tags;
                const categories = categoriesString.split(", ");
                const containsInStoreOnly =
                  categories.includes("in-store-only");

                let wishlistItemButton = `<div class="product-block"><form id="algolia-add-to-cart-${
                  e.product_id
                }" class="product-form product-form--mini" style="" action="/cart/add" method="post" accept-charset="UTF-8" enctype="multipart/form-data" data-ajax-add-to-cart="true" data-product-id="${
                  e.product_id
                }">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${e.variant_id}"  />
                    <button type="submit" name="add" class="btn product-add" style="border: 1px solid black;padding: 10px;">ADD TO BASKET</button>
                </form>                    
            
                <div class="qty-adjuster-container">
                    <div class="qty-adjuster qty-adjuster--ajax qty-adjuster--has-subtext" data-limit="${
                      e.total_inventory && e.in_stock > 0
                        ? e.total_inventory
                        : 999
                    }">
                    <div class="qty-adjuster__inner">
                        <button class="btn qty-adjuster__down"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>
                        <input class="qty-adjuster__value" type="text" pattern="[0-9]*" name="quantity" value="">
                        <button class="btn qty-adjuster__up"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>
                    </div>
                    <div class="qty-adjuster__subtext">in your cart</div>
                    </div>
                </div></div>`;
                if (containsInStoreOnly) {
                  wishlistItemButton = "";
                }
                (a +=
                  '<div class="wishlist-card" data-id="' +
                  e.id +
                  '" data-handle="' +
                  e.handle +
                  '" data-proID="' +
                  e.product_id +
                  '" data-varID="' +
                  e.variant_id +
                  '"><div class="wishlist__product">'),
                  (a +=
                    '<div class="wishlist__product-img" data-hulkQuickViewEle><a href="/products/' +
                    e.handle +
                    '" class="wishlist-product__image"><img data-hulkQuickViewEle src="' +
                    e.image +
                    '" alt="' +
                    e.title +
                    '" class="img-list"></a><p class="item__delete grid__view"><a href="#" data-HulkDeleteProduct class="icon-wishlist-remove hulkThemeColor"></a></p> </div>'),
                  (a += '<div class="wishlist__product-content">'),
                  null != e.vendor &&
                    null != e.vendor &&
                    e.vendor.length > 0 &&
                    (a += '<p class="vendor">' + "</p>"),
                  (a +=
                    '<p class="product__title">' +
                    e.title +
                    '</p><p class="price">' +
                    e.price +
                    "</p></p></div>"),
                  (a += '<div class="wishlist-status">'),
                  1 == e.in_stock
                    ? (a += wishlistItemButton)
                    : (a +=
                        '<span class="" disabled>' +
                        WishlistSettings.language.button.out_of_stock +
                        "</span>"),
                  (a +=
                    '<p class="added_date grid__view">' +
                    WishlistSettings.language.date_label +
                    " " +
                    e.added_on +
                    "</p></div>"),
                  (a += "</div></div>");
              }),
              (document.querySelectorAll(
                "[data-HulkListViewContainer]"
              )[0].innerHTML = ""),
              (document.querySelectorAll(
                "[data-HulkListViewContainer]"
              )[0].style.display = "none"),
              (document.querySelectorAll(
                "[data-HulkGridViewContainer]"
              )[0].innerHTML = a),
              (document.querySelectorAll(
                "[data-HulkGridViewContainer]"
              )[0].style.display = "flex"))
            : (l.forEach(function (e) {
                console.log(e);
                const categoriesString = e.tags;
                const categories = categoriesString.split(", ");
                const containsInStoreOnly =
                  categories.includes("in-store-only");

                let wishlistItemButton = `<div class="product-block"><form id="algolia-add-to-cart-${
                  e.product_id
                }" class="product-form product-form--mini" style="" action="/cart/add" method="post" accept-charset="UTF-8" enctype="multipart/form-data" data-ajax-add-to-cart="true" data-product-id="${
                  e.product_id
                }">
                        <input type="hidden" name="form_type" value="product">
                        <input type="hidden" name="utf8" value="✓">
                        <input type="hidden" name="id" value="${
                          e.variant_id
                        }"  />
                        <button type="submit" name="add" class="btn product-add" style="border: 1px solid black;padding: 10px;">ADD TO BASKET</button>
                    </form>                    
                
					<div class="qty-adjuster-container">
                        <div class="qty-adjuster qty-adjuster--ajax qty-adjuster--has-subtext" data-limit="${
                          e.total_inventory && e.in_stock > 0
                            ? e.total_inventory
                            : 999
                        }">
                        <div class="qty-adjuster__inner">
                            <button class="btn qty-adjuster__down"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>
                            <input class="qty-adjuster__value" type="text" pattern="[0-9]*" name="quantity" value="">
                            <button class="btn qty-adjuster__up"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>
                        </div>
                        <div class="qty-adjuster__subtext">in your cart</div>
                        </div>
                    </div></div>`;

                if (containsInStoreOnly) {
                  wishlistItemButton = "";
                }

                (a +=
                  '<div class="wishlist-card" data-id="' +
                  e.id +
                  '" data-handle="' +
                  e.handle +
                  '" data-proID="' +
                  e.product_id +
                  '" data-varID="' +
                  e.variant_id +
                  '"><div class="wishlist__product">'),
                  (a +=
                    '<div class="wishlist__product-img" data-hulkQuickViewEle><a href="/products/' +
                    e.handle +
                    '" class="wishlist-product__image"><img data-hulkQuickViewEle src="' +
                    e.image +
                    '" alt="' +
                    e.title +
                    '" class="img-list"></a></div>'),
                  (a +=
                    '<div class="wishlist_product-content-container"><div class="wishlist__product-content">'),
                  null != e.vendor &&
                    null != e.vendor &&
                    e.vendor.length > 0 &&
                    (a += '<p class="vendor">' + "</p>"),
                  (a +=
                    '<p class="product__title">' +
                    e.title +
                    '</p><p class="price">' +
                    e.price +
                    "</p></div>"),
                  (a +=
                    '<div class="wishlist-status">' +
                    '<p class="added_date list__view">' +
                    WishlistSettings.language.date_label +
                    " " +
                    e.added_on +
                    "</p>"),
                  1 == e.in_stock
                    ? (a += wishlistItemButton)
                    : (a +=
                        '<span class="" disabled>' +
                        WishlistSettings.language.button.out_of_stock +
                        "</span>"),
                  (a +=
                    '<p class="item__delete list__view"><a href="#" class="hulkThemeColor" data-HulkDeleteProduct>' +
                    WishlistSettings.language.button.delete +
                    "</a></p>" +
                    "</div></div>"),
                  (a += "</div></div>");
              }),
              (document.querySelectorAll(
                "[data-HulkListViewContainer]"
              )[0].innerHTML = a),
              (document.querySelectorAll(
                "[data-HulkListViewContainer]"
              )[0].style.display = "block"),
              (document.querySelectorAll(
                "[data-HulkGridViewContainer]"
              )[0].innerHTML = ""),
              (document.querySelectorAll(
                "[data-HulkGridViewContainer]"
              )[0].style.display = "none")),
          s._updateWishlistButton());

        $(".hulk__wishlist-wrap .wishlist-card").each(function () {
          var item = $(this);
          theme.loadInPlaceQuantityAdjustment(item);
          theme.applyAjaxToProductAlgoliaForm($(item));
        });
      },
      _hulkQuickView: function () {
        document.addEventListener("click", function (e) {
          if (e.target && 1 == e.target.hasAttribute("data-hulkquickviewele")) {
            e.preventDefault();
            var t = e.target,
              l = t.closest(".wishlist-card").getAttribute("data-handle"),
              a = t.closest(".wishlist-card").querySelector(".price").innerHTML;
            if (null != l && null != l && "" != l) {
              var i = new XMLHttpRequest();
              i.open("GET", "/products/" + l + ".js", !0),
                i.send(),
                (i.onload = function () {
                  if (200 == i.status) {
                    var e = JSON.parse(this.response),
                      t = "",
                      l = "",
                      r = document.querySelectorAll("[data-hulkQuickView]")[0];
                    var categoriesString = e.tags;
                    var containsInStoreOnly =
                      categoriesString.includes("in-store-only");
                    e.images.length > 0 &&
                      e.images.forEach(function (s, a) {
                        0 == a
                          ? ((t +=
                              '<div class="item active"><img class="carousel-cell-image" src="' +
                              s +
                              '" alt="' +
                              e.handle +
                              '"/></div>'),
                            (l += '<li class="active"></li>'))
                          : ((t +=
                              '<div class="item"><img class="carousel-cell-image" src="' +
                              s +
                              '" alt="' +
                              e.handle +
                              '"/></div>'),
                            (l += '<li class=""></li>'));
                      }),
                      (document
                        .querySelectorAll("[data-mainCarousal]")[0]
                        .querySelector(".carousel-inner").innerHTML = t),
                      (document.querySelectorAll(
                        "[data-navCarousel]"
                      )[0].innerHTML = l),
                      (document.querySelectorAll("[data-vendor]")[0].innerHTML =
                        e.vendor),
                      "Default Title" != e.variants[0].title
                        ? (document.querySelectorAll(
                            "[data-title]"
                          )[0].innerHTML =
                            e.title + " (" + e.variants[0].title + ")")
                        : (document.querySelectorAll(
                            "[data-title]"
                          )[0].innerHTML = e.title),
                      null != a &&
                        null != a &&
                        (document.querySelectorAll(
                          "[data-price]"
                        )[0].innerHTML = a),
                      (document.querySelectorAll(
                        "[data-shortDscription]"
                      )[0].innerHTML = e.description),
                      document
                        .querySelectorAll("[data-goToProduct]")[0]
                        .setAttribute("href", "/products/" + e.handle),
                      document
                        .querySelectorAll(
                          "[data-hulkquickview].wishlist-card"
                        )[0]
                        .setAttribute("data-varid", e.variants[0].id),
                      containsInStoreOnly == 1
                        ? (document.querySelectorAll(
                            "[data-hulkquickview] [data-addprotocart]"
                          )[0].style.display = "none")
                        : (document.querySelectorAll(
                            "[data-hulkquickview] [data-addprotocart]"
                          )[0].style.display = "block"),
                      0 == e.variants[0].available || 0 == e.available
                        ? ((document.querySelectorAll(
                            "[data-hulkquickview] [data-addprotocart]"
                          )[0].innerHTML = "Out Of Stock"),
                          (document.querySelectorAll(
                            "[data-hulkquickview] [data-addprotocart]"
                          )[0].disabled = !0))
                        : ((document.querySelectorAll(
                            "[data-hulkquickview] [data-addprotocart]"
                          )[0].innerHTML =
                            WishlistSettings.language.button.move_to_cart),
                          (document.querySelectorAll(
                            "[data-hulkquickview] [data-addprotocart]"
                          )[0].disabled = !1)),
                      s._slider(),
                      r.classList.add("open");
                  } else if (404 == i.status) {
                    s._messageUpdate(
                      "Product Details are not available at this moment!"
                    );
                  } else {
                    var n = JSON.parse(this.response),
                      o = "Something Went wrong. Please Try again later !";
                    n.message && (o = n.message), s._messageUpdate(o);
                  }
                });
            }
          }
        });
      },
      _someBaseFunction: function () {
        null != document.querySelectorAll("[data-closeWishlistPopup]") &&
          null != document.querySelectorAll("[data-closeWishlistPopup]") &&
          document
            .querySelectorAll("[data-closeWishlistPopup]")
            .forEach(function (e) {
              e.onclick = function (e) {
                document
                  .querySelectorAll("[data-hulkappsWishlistPopup]")[0]
                  .classList.remove("open"),
                  document
                    .querySelectorAll("[data-HulkappsShare]")[0]
                    .classList.remove("open"),
                  document
                    .querySelectorAll("[data-HulkappsSubscribe]")[0]
                    .classList.remove("open"),
                  document
                    .querySelectorAll("[data-hulkQuickView]")[0]
                    .classList.remove("open"),
                  document
                    .querySelectorAll("[data-hulkappsDeletePrompt]")[0]
                    .classList.remove("open"),
                  document
                    .querySelectorAll("[data-hulkappsDeletePrompt]")[0]
                    .removeAttribute("data-wishlist"),
                  (document
                    .querySelectorAll("[data-HulkappsShare]")[0]
                    .querySelector("[data-shareURL]").value = ""),
                  (document
                    .querySelectorAll("[data-HulkappsSubscribe]")[0]
                    .querySelector('[name="email"]').value = "");
              };
            }),
          null != document.querySelectorAll("[data-openCreateSection]")[0] &&
            null != document.querySelectorAll("[data-openCreateSection]")[0] &&
            (document.querySelectorAll("[data-openCreateSection]")[0].onclick =
              function (e) {
                e.preventDefault(),
                  (document.querySelectorAll(
                    "[data-addNewWishlist]"
                  )[0].style.display = "block"),
                  (document.querySelectorAll(
                    "[data-openCreateSection]"
                  )[0].style.display = "none");
              }),
          document.addEventListener("click", function (e) {
            if (
              e.target &&
              1 == e.target.hasAttribute("data-hulkwishlistview")
            ) {
              e.preventDefault();
              var t = e.target
                .closest("[data-userhulkwishlist]")
                .getAttribute("data-id");
              (SelectedWishlistID = t), s._getWishlistProducts(t, 1);
            }
          }),
          (document.querySelectorAll("[data-hulklistview]")[0].onclick =
            function (e) {
              e.preventDefault(),
                (selectedLayout = "list"),
                s._wishlistLayout(selectedLayout, selectedWishlist),
                document
                  .querySelectorAll("[data-hulklistview]")[0]
                  .classList.add("change__view-active"),
                document
                  .querySelectorAll("[data-hulkgridview]")[0]
                  .classList.remove("change__view-active");
            }),
          (document.querySelectorAll("[data-hulkgridview]")[0].onclick =
            function (e) {
              e.preventDefault(),
                (selectedLayout = "grid"),
                s._wishlistLayout(selectedLayout, selectedWishlist),
                document
                  .querySelectorAll("[data-hulkgridview]")[0]
                  .classList.add("change__view-active"),
                document
                  .querySelectorAll("[data-hulklistview]")[0]
                  .classList.remove("change__view-active");
            }),
          document
            .querySelectorAll("[data-hulkpagination] .pagination-link")
            .forEach(function (e) {
              e.addEventListener("click", function (e) {
                e.preventDefault();
                var t = e.target.getAttribute("data-page");
                "guest" == customerStatus
                  ? s._guestWishlistAPI(productIDListing, t)
                  : s._getWishlistProducts(SelectedWishlistID, t);
              });
            });
      },
      _removeFromWishlist: function () {
        document.addEventListener("click", function (e) {
          if (
            e.target &&
            1 == e.target.hasAttribute("data-hulkdeleteproduct")
          ) {
            e.preventDefault();
            var t = e.target.closest(".wishlist-card");

            if ("guest" == customerStatus) {
              var l = t.getAttribute("data-proid");
              s._removeFromGuestWishlist(l);
            } else {
              var a = {
                  customer_id: customerID,
                  shop: hulkShopDomain,
                  product_id: t.getAttribute("data-proid"),
                  variant_id: t.getAttribute("data-varid"),
                  wishlist_ids: [SelectedWishlistID],
                },
                i = new XMLHttpRequest();

              i.open(
                "POST",
                window.hulkappsWishlist.baseURL + "/wishlist/delete_product"
              ),
                i.setRequestHeader("Content-type", "application/json"),
                i.setRequestHeader('Encrypt-token', btoa(CryptoJS.SHA256('planet-organic-uk.myshopify.com'+customerID).toString()));
                i.send(JSON.stringify(a)),
                (i.onload = function () {
                  if (200 == i.status) {
                    var e = JSON.parse(this.response),
                      t = selectedWishlist.total;
                    t -= 1;
                    var l = document
                      .querySelectorAll("[data-HulkPagination]")[0]
                      .querySelector("[data-currentpage]").innerHTML;
                    s._getWishlistProducts(SelectedWishlistID, l),
                      document.querySelectorAll(
                        '[data-userhulkwishlist][data-id="' +
                          SelectedWishlistID +
                          '"]'
                      )[0] &&
                        (document
                          .querySelectorAll(
                            '[data-userhulkwishlist][data-id="' +
                              SelectedWishlistID +
                              '"]'
                          )[0]
                          .getElementsByTagName("span")[0].innerHTML =
                          "(" + t + ")");
                    var a = "Item removed!";
                    e.message && (a = e.message), s._messageUpdate(a);
                  } else {
                    var r = JSON.parse(this.response),
                      n = "Something Went wrong. Please Try again later !";
                    r.message && (n = r.message), s._messageUpdate(n);
                  }
                });
            }
            wishlistTotal && s._updateWishlistTotal();
          }
        });
      },
      _addProductTocart: function () {
        document.addEventListener("click", function (e) {
          if (e.target && 1 == e.target.hasAttribute("data-addprotocart")) {
            e.preventDefault();
            var t = e.target,
              l = t.closest(".wishlist-card"),
              a = l.getAttribute("data-proid"),
              i = l.getAttribute("data-varid"),
              r = {
                id: l.getAttribute("data-varid"),
                quantity: 1,
              };
            fetch("/cart/add.json", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(r),
            }).then(function (e) {
              if (200 === e.status)
                (t.innerHTML = "Added !"),
                  setTimeout(function () {
                    WishlistSettings.general.delete_on_move_to_wishlist &&
                      null != l.querySelector("[data-hulkdeleteproduct]") &&
                      null != l.querySelector("[data-hulkdeleteproduct]") &&
                      l.querySelector("[data-hulkdeleteproduct]").click(),
                      (t.innerHTML =
                        WishlistSettings.language.button.move_to_cart);
                  }, 2e3),
                  "guest" != customerStatus && s._updateRevenueCount(a, i),
                  (window.location.href = "/cart");
              else {
                var r = "Something went wrong! Please Try again later.";
                e.message && (r = e.message), s._messageUpdate(r);
              }
            });
          }
        });
      },
      _updateRevenueCount: function (e, t) {
        var s = {
            customer_id: customerID,
            shop: hulkShopDomain,
            product_id: e,
            variant_id: t,
            qty: 1,
          },
          l = new XMLHttpRequest();
        l.open("POST", window.hulkappsWishlist.baseURL + "/wishlist/revenue"),
          l.setRequestHeader("Content-type", "application/json"),
          l.send(JSON.stringify(s)),
          (l.onload = function () {
            200 == l.status && console.log(this.response);
          });
      },
      _updatePixels: function () {
        if ("" != WishlistSettings.general.facebook_pixel_code) {
          var e = document.createElement("script");
          (e.innerHTML =
            "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n"),
            (e.innerHTML +=
              "if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;\nt.src=v;s=b.getElementsByTagName(e)[0];"),
            (e.innerHTML +=
              "s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');"),
            (e.innerHTML +=
              "fbq('init', '" +
              WishlistSettings.general.facebook_pixel_code +
              "');\n fbq('track', 'PageView');"),
            document.getElementsByTagName("head")[0].appendChild(e);
        }
        if ("" != WishlistSettings.general.google_conversion_tracking_code) {
          var t = document.createElement("script");
          t.setAttribute(
            "src",
            "https://www.googletagmanager.com/gtag/js?id=" +
              WishlistSettings.general.google_conversion_tracking_code
          ),
            (t.async = !0);
          var s = document.createElement("script");
          (s.innerHTML =
            "window.dataLayer = window.dataLayer || [];\n function gtag(){dataLayer.push(arguments);} \n"),
            (s.innerHTML +=
              "gtag('js', new Date()); \n gtag('config', '" +
              WishlistSettings.general.google_conversion_tracking_code +
              "');"),
            document.getElementsByTagName("head")[0].appendChild(t),
            document.getElementsByTagName("head")[0].appendChild(s);
        }
      },
      _searchWishlist: function () {
        var e,
          t = document
            .querySelectorAll("[data-searchWishlist]")[0]
            .querySelector("input");
        (t.onkeyup = function () {
          var l = t.value;
          (l = l.trim()),
            (searchTerm = l),
            clearTimeout(e),
            (e = setTimeout(function () {
              "guest" == customerStatus
                ? s._guestWishlistAPI(productIDListing, 1)
                : s._getWishlistProducts(SelectedWishlistID, 1);
            }, 1e3));
        }),
          (t.keydown = function () {
            clearTimeout(e);
          });
      },
      _updateWishlistTotal: function () {
        if ("guest" == customerStatus)
          guestWishlistData
            ? (wishlistTotal.innerHTML = " (" + guestWishlistData.length + ")")
            : (wishlistTotal.innerHTML = " (0)");
        else {
          var e = new XMLHttpRequest();
          e.open(
            "GET",
            window.hulkappsWishlist.baseURL +
              "/wishlist/count?customer_id=" +
              customerID +
              "&shop=" +
              hulkShopDomain
          ),
            e.setRequestHeader("Content-type", "application/json"),
            e.send(),
            (e.onload = function () {
              if (200 == e.status) {
                var t = JSON.parse(this.response);
                wishlistTotal.innerHTML = " (" + t.wishlist_count + ")";
              }
            });
        }
      },
    };
    document.addEventListener("DOMContentLoaded", function (e) {
      s.init();
    });
  },
});
